export enum ViewContextActions {
  ShowMainTransactionDataFormView,
  MakeRequest,
  ShowResult,
  ShowError,
  ShowSpinner,
}
